import React, { useContext } from 'react';

import { app, variant } from '../context';
import ResultItem from './ResultItem';

import { VARIANTS, STACK_OPTIONS, NUM_RESULTS } from '../constants';

export default () => {
  const {
    price,
    speed,
    bonus,
    doubled,
    upgradeRate,
    target,
    walkTime,
  } = useContext(app);

  const startTime = Date.now();

  const stackOptions = STACK_OPTIONS.filter(s => s <= target);
  const results = stackOptions
    .map(stack => {
      let time = Number.MAX_VALUE;
      let upgrades = 0;
      let stageTimeAcc = 0;

      const maxBuys = parseInt(target / stack, 10);
      for (let i = 0; i < maxBuys; i++) {
        const spd = speed + i * stack * bonus * (doubled ? 2 : 1);
        const lastTripTime =
          (target - stack * i) * (price / spd + upgradeRate) + walkTime;

        const totalTime = lastTripTime + stageTimeAcc;
        if (totalTime > time) break;
        time = totalTime;
        upgrades = i;
        stageTimeAcc += stack * (price / spd + upgradeRate) + walkTime;
      }
      return { stack, time, upgrades };
    })
    .filter(
      (elm, idx, arr) =>
        elm.upgrades > 0 || elm === arr.find(t => t.upgrades === 0),
    )
    .sort((a, b) => a.time - b.time)
    .slice(0, NUM_RESULTS);

  const calcTime = Date.now() - startTime;

  return (
    <div className="row">
      <div className="col col-4 text-right">交換戦略</div>
      <div className="col">
        {results.map((result, idx) => (
          <variant.Provider key={idx} value={VARIANTS[idx]}>
            <ResultItem {...result} />
          </variant.Provider>
        ))}
        <small className="text-secondary">{`calculation time: ${calcTime} ms`}</small>
      </div>
    </div>
  );
};
